export const MY_ACCOUNT_PAGE_SECTION = 'My Account';
export const MY_ACCOUNT_PAGE_STAGE = 'My Account';

export const ORDER_HISTORY_PAGE_NAME = 'My Account:Order History';

export const EDIT_DESIGN_AND_REORDER_CTA_VALUE = 'Edit design & reorder';
export const REORDER_PRODUCT_ADDED_TO_CART_EVENT_NAME = 'Product Added';
export const NAVIGATION_CLICKED_EVENT_NAME = 'Navigation Clicked';
export const STUDIO_DESTINATION_PAGE_PATH = 'Studio';
export const BUY_IT_AGAIN_PAGE_ZONE = 'Buy It Again';
export const BUTTON_CLICKED_EVENT_NAME = 'Button Clicked';

// flawed ux tracking
export const FLAWED_UX_SOURCE = 'orderHistory';
export const FLAWED_ADD_TO_CART_EXPERIENCE = 'Add To Cart Error';
export const ATC_WRAPPER_SERVICE_FLAWED_UX_REASON =
  'ATC wrapper service failure';
export const ITEM_ADD_FAILURE_REASON = {
  DOC_CONVERSION: 'Document conversion reorder failure',
  PRODUCT_UNAVAILABLE: 'Product unavailable reorder failure',
  GENERIC: 'Generic OREOS reorder failure',
};
